import React from "react";

const Footer = () => {
  var d = new Date();
  return (
    <div className="footer" style={{position : "absolute", paddingLeft :"0px", zIndex : 4, width: "100%"}}>
      <div className="copyright">
      2022 © BABIES GETAWAY US LTD - CONTACT YOUR ADMINISTRATOR FOR ANY LOGIN ISSUES.
      <br/>For Technical Support Contact 844-795-1539
    </div>
    </div>
    // <div className="copyright">
    //   2022 © BABIES GETAWAY US LTD - CONTACT YOUR ADMINISTRATOR FOR ANY LOGIN ISSUES.
    //   <br/>For Technical Support Contact 844-795-1539
    // </div>
  );
};

export default Footer;
